/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export const convertToBoolean = (element: string | number): boolean => {
  switch (element) {
    case 'on':
    case 'true':
    case 1:
    case '1':
      return true;
    case '0':
    case 'off':
    case 'false':
    case 0:
      return false;
    default:
      return false;
  }
};
